import {
  Box,
  Button,
  Center,
  Checkbox,
  Container,
  Flex,
  Heading,
  Image,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react'
import {
  useFetchStampedPDFMutation,
  useGetStampPaperStatusQuery,
  useSendOTPforStampPaperMutation,
  useVerifyOtpForStampPaperMutation,
} from 'Services/API/posp.api'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import axios from 'axios'

import { Page, Document, pdfjs } from 'react-pdf'

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/legacy/build/pdf.worker.min.js`
import 'react-pdf/dist/esm/Page/AnnotationLayer.css'
import OtpVerificationModal from 'Components/OtpVerificationModal'
import { ToastService } from 'Services/toast.service'
import { PospImages } from 'Assets/Posp'
import { POSP_URL } from 'Constants'

const Esign = () => {
  const { uuid } = useParams()
  const [otpModalOpen, setOtpModalOpen] = useState(false)
  const [numPages, setNumPages] = useState<number>()
  const [pageNumber, setPageNumber] = useState<number>(1)
  const [pdfUrl, setPdfUrl] = useState('')
  const [aggrementChecked, setAggrementChecked] = useState(false)
  const [otpInput, setOtpInput] = useState('')
  const [pagesArray, setPagesArray] = useState<any>([])
  const [isVerified, setIsVerified] = useState(false)
  const [signedDocumentUrl, setSignedDocumentUrl] = useState('')
  const [size, setSize] = useState({ w: 430, h: 510 })

  const onDocumentLoadSuccess = ({ numPages }: { numPages: number }): void => {
    setNumPages(numPages)
    const newarr = []
    for (let i = 0; i < numPages; i++) {
      newarr.push(i)
    }
    setPagesArray(newarr)
    console.log('numofPages, ', numPages)
  }

  console.log('pdfUrl', pdfUrl)

  const [fetchStampedPDF, { isLoading: isPDFLoading }] = useFetchStampedPDFMutation()
  const [sendOTP, { isLoading: sendOTPLoading }] = useSendOTPforStampPaperMutation()
  const [verifyOTP, { isLoading: verifyOtpLoading }] = useVerifyOtpForStampPaperMutation()
  const {
    data: stampStatusData,
    isSuccess: stampStatusSuccess,
    isError: stampStatusErrored,
  } = useGetStampPaperStatusQuery({ uuid }, { skip: !uuid })
  const alreadyVerified = !!stampStatusData?.data?.is_signed
  const maskedPhone: string | undefined = stampStatusData?.data?.masked_phone
  const maskedEmail: string | undefined = stampStatusData?.data?.masked_email

  const getBlob = () => {
    return fetch(`${POSP_URL}/common/fetch_stamp_paper/`, {
      method: 'POST',
      body: JSON.stringify({ uuid }),
      headers: {
        'content-type': 'application/*',
      },
    }).then((t) => {
      if (t.status === 200) {
        return t.blob()
      }
      return null
    })
  }

  const handleFetchPdf = async () => {
    // const pdfResp: any = axios
    //   .post('https://posp-dev.zopperinsurance.com/common/fetch_stamp_paper/', {
    //     uuid: uuid,
    //   })
    //   .then((t: any) => t.blob())

    const pdfBlob: any = await getBlob()
    console.log('pdfResp: ', pdfBlob)
    if (pdfBlob) {
      const previousFile = URL.createObjectURL(pdfBlob)
      setPdfUrl(previousFile)
    } else {
      ToastService.showErrorToast({
        title: 'Error',
        message: 'File Load Failed',
      })
      setPdfUrl('abc')
    }
  }

  const handleSendOTP = async () => {
    try {
      const handleSendOtpResp = await sendOTP({ uuid: uuid })
      console.log('handleSendOtpResp', handleSendOtpResp)
      setOtpModalOpen(true)
    } catch (err) {
      console.log('err', err)
    }
  }
  useEffect(() => {
    if (!uuid) return
    if (!stampStatusSuccess && !stampStatusErrored) return

    // Set signed document URL if already verified and available in status
    if (stampStatusData?.data?.document_url) {
      setSignedDocumentUrl(stampStatusData.data.document_url)
    }

    if (alreadyVerified) return
    handleFetchPdf()
  }, [uuid, stampStatusSuccess, stampStatusErrored, alreadyVerified, stampStatusData])

  const handleVerifyOtpClick = async () => {
    try {
      const verifyOtpResp = await verifyOTP({ uuid: uuid, otp: otpInput }).unwrap()
      console.log('verifyOtpResp', verifyOtpResp)

      // Extract document_url from verification response
      if (verifyOtpResp?.data?.document_url) {
        setSignedDocumentUrl(verifyOtpResp.data.document_url)
      }

      setOtpModalOpen(false)
      setIsVerified(true)
    } catch (err) {
      console.log('err', err)
    }
  }
  return (
    <>
      <Modal
        isOpen={isVerified || alreadyVerified}
        onClose={() => {
          console.log('')
        }}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalBody py={10}>
            <Flex alignItems={'center'} flexDirection={'column'}>
              <Image mb={5} src={PospImages.SucceedIcon} height={'70px'} w={'70px'} />

              <Text mb={3} fontSize={'md'} fontWeight={'bold'}>
                {isVerified ? 'Thank you for your response' : 'Already Verified'}
              </Text>
              <Text mb={3} fontSize={'sm'} textAlign={'center'}>
                {isVerified
                  ? 'You may download your certificates by logging in again.'
                  : 'You have already verified this agreement. You may download your certificates by logging in again.'}
              </Text>

              {signedDocumentUrl && (
                <Button
                  as='a'
                  href={signedDocumentUrl}
                  target='_blank'
                  download='Signed_Agreement.pdf'
                  colorScheme='blue'
                  variant='solid'
                  rounded='full'
                  px={10}
                  mt={4}
                >
                  {stampStatusData?.data?.type === 'LIFE'
                    ? 'Download Appointment Letter PDF'
                    : 'Download Agreement PDF'}
                </Button>
              )}
            </Flex>
          </ModalBody>
        </ModalContent>
      </Modal>
      <OtpVerificationModal
        showGoBackToRegistration={false}
        handleResendOTP={handleSendOTP}
        isOpen={otpModalOpen}
        onClose={() => setOtpModalOpen(false)}
        loginPhoneNumber={''}
        maskedPhone={maskedPhone}
        maskedEmail={maskedEmail}
        otpInput={otpInput}
        setOtpInput={setOtpInput}
        isLoading={verifyOtpLoading}
        verifyClickHandler={handleVerifyOtpClick}
      />
      <Container bgColor={'#F9FAFA'} h='100vh' maxW='1000px' position={'relative'}>
        {!alreadyVerified && (
          <>
            <Heading py={3} px={5} fontSize={'lg'}>
              Posp Agreement
            </Heading>
            <Center>
              <Box height={'70vh'} w='100%' overflow={'scroll'}>
                {isPDFLoading || !pdfUrl ? (
                  <Box>Loading... </Box>
                ) : (
                  <Document
                    renderMode='canvas'
                    file={pdfUrl}
                    //   file='https://foundation-dev.theblackswan.in/media/UHYR-IH_A0WjJDp91D788g=='

                    onLoadSuccess={onDocumentLoadSuccess}
                  >
                    {pagesArray.map((val: any, ind: number) => (
                      <Page key={ind} pageNumber={val + 1} />
                    ))}
                  </Document>
                )}
              </Box>
            </Center>
          </>
        )}

        {!alreadyVerified && (
          <Center>
            <Box
              position={'absolute'}
              bottom={0}
              h='22vh'
              mt={10}
              background={'#FFFFFF 0% 0% no-repeat padding-box'}
              w={'100%'}
            >
              <Box py={5}>
                <Flex flexDirection={'column'} w='100%' alignItems={'center'}>
                  <Box w='80%'>
                    <Heading mb={5} fontSize={'lg'}>
                      Verification
                    </Heading>
                    <Checkbox
                      checked={aggrementChecked}
                      onChange={(e) => setAggrementChecked(e.target.checked)}
                    >
                      {stampStatusData?.data?.type === 'LIFE'
                        ? 'By checking this box, I agree to the terms and conditions set out in the appointment letter.'
                        : 'By checking this box, I agree to the terms and conditions as set out by the user agreement.'}
                    </Checkbox>
                  </Box>
                </Flex>
              </Box>

              <Center>
                <Button
                  onClick={handleSendOTP}
                  isDisabled={!aggrementChecked || !numPages}
                  px={10}
                  rounded={'20px'}
                >
                  Submit
                </Button>
              </Center>
            </Box>
          </Center>
        )}
      </Container>
    </>
  )
}

export default Esign
